export enum ConnectionStatus {
    CONNECTED = 'CONNECTED',
    OFFLINE = 'OFFLINE',
}
